import { useAxios } from './axiosService';

export const usePaymentService = () => {
    const { axios } = useAxios();

    const createPaymentIntent = async body => {
        return await axios.post(`/payments/create-payment-intent`, body);
    };

    const createCheckoutSession = async body => {
        const { data } = await axios.post('/credits/create-checkout-session', {
            ...body,
        });

        return data;
    };

    return { createPaymentIntent, createCheckoutSession };
};
